<template>
	<div ref="button" 
		class="button" 
		:class="{disable}" 
		:style="'pointer-events:' + (disable?'none':'all')"
		@mouseenter="mouseOver"
		@mouseout="mouseOut">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name:"dy-button",
		props:{
			disable:{
				type:Boolean,
				default:false,
			},
			tooltip:{
				type:String,
				default:'',
			},
			type:{
				type:String,
				default:'bottom',
			},
			
		},
		data() {
			return {
				elem:null,
			};
		},
		methods:{
			mouseOver(e){
				let sw	 = document.body.offsetWidth;
				let sh	 = document.body.offsetHeight;
				let rect = this.$refs.button.getBoundingClientRect();
				//提示
				if(this.tooltip && !this.elem){
					let elem = document.createElement('div');
					
					elem.classList.add('dy-tooltip');
					elem.innerHTML	= this.tooltip;
					document.body.appendChild(elem);
					
					let x	 = -elem.offsetWidth /2 + rect.width /2;
					let y	 = -elem.offsetHeight /2 + rect.height /2;
					
					if(rect.x + elem.offsetWidth > sw) x -= (rect.x + elem.offsetWidth -sw) /2;
					if(rect.y + rect.height + elem.offsetHeight > sh) {
						y -= elem.offsetHeight /2 + 20;
					} else {
						y += elem.offsetHeight /2 + 20;
					}
					
					elem.style.left		 = rect.x + 'px';
					if(this.type == 'bottom'){
						elem.style.top		= rect.y + 'px';
					}else{
						elem.style.top		= rect.y - elem.offsetHeight + 'px';
						y = rect.height / 2 - 20;
					}
					elem.style.transform = 'translate('+x+'px,'+y+'px)'; 	
					
					this.elem = elem;
				}				
			},
			mouseOut(e){
				this.elem && document.body.removeChild(this.elem);
				this.elem = null;
			},
		}
	}
</script>

<style>
	.button{
		position: relative;
		color:#fff;
		background-color: #252529;
		height:30px;
		line-height:30px;
		padding:0 10px;
		border-radius:15px;
		font-size:14px;
		box-sizing: border-box;
		cursor: pointer;
		text-align: center;
		background-size: 16px 16px;
		background-position: 10px center;
		background-repeat: no-repeat;
		overflow: hidden;
		text-overflow: ellipsis;
		flex-shrink: 0;
	}
	.button:after{
		position:absolute;
		width:16px;
		height:16px;
		line-height:16px;
		font-family:'iconfont';
		font-size:16px;	
		left:5px;
		top:50%;
		margin-top:-8px;
		box-sizing: border-box;
	}
	.button:hover{
		background-color:#383838;
	}
	/* .button:active{
		background-color:rgb(30,100,240);
	}
	 */
	.button.active{
		background:linear-gradient(-45deg,#7d65f8,#3999ca)
	}
	.button.active:hover{
		background:linear-gradient(-45deg,#8d75ff,#49a9da)
	}
	/* .button.active:active{
		background-color:rgb(30,100,240);
	} */
	.disable{
		background:#90959f !important;
	}
	.disable:hover{
		background-color:#90959f !important;
	}
	.disable:active{
		background-color:#90959f !important;
	}
	.black{
		color:#909090;
		background-color:transparent;
	}
	.black:hover{
		color:#aaa;
		background-color:transparent;
	}
</style>